module.exports = __webpack_public_path__ + "img/home_slide_02.f7036fcd.png";